module.exports = __webpack_public_path__ + "img/cicle-add-white-icon.0bb6f737.svg";